module.exports = __webpack_public_path__ + "media/images/vp/icon.leftarrow2.darkblue-6e1e1bf1e67060092d4e142895e6ab40.svg";